import { Vehicle } from '../types/vehicle';
import ElectricCarBannerAbbreviated from '@/icons/electric-car-banner-abbreviated';
import Spacer from '@/common/components/spacer';
import VehicleBasicInfo from './vehicle-basic-info';
import PickupAvailability from './pickup-availability';
import NewVehiclePill from '@/catalog/components/pdp/vehicle-pills/new-vehicle-pill';

interface VehicleTitleProps {
  vehicle: Vehicle;
  isNewVehicle?: boolean;
}

export default function VehicleTitle({ vehicle, isNewVehicle }: VehicleTitleProps) {
  return (
    <div className="flex w-full flex-col items-center md:items-start">
      <h3 className="inline-flex gap-[8px]">
        {vehicle.model_year}
        {isNewVehicle ? <NewVehiclePill /> : ''}
      </h3>
      <Spacer variant="height8" />

      <div className="flex w-full flex-row justify-between py-[8px]">
        <div className="w-full">
          <h1 className="break-words text-center md:text-start">
            {vehicle.make} {vehicle.model}
            {vehicle.trim ? (
              <span className="body2-strong relative top-[-4px] ml-[8px] rounded-[8px] bg-flexcar-neutral0 px-[8px] py-[4px] text-flexcar-neutral100">
                {vehicle.trim}
              </span>
            ) : null}
            {vehicle.is_electric ? (
              <span className="relative top-[3px] ml-[8px] inline-flex">
                <ElectricCarBannerAbbreviated />
              </span>
            ) : null}
          </h1>
        </div>

        <div className="hidden md:block">
          <VehicleBasicInfo vehicle={vehicle} />
        </div>
      </div>

      <PickupAvailability
        pickupDays={vehicle.pickup_days}
        earliestAvailableDate={vehicle.earliest_available_date}
        variant="body2"
      />

      <div className="block md:hidden">
        <Spacer variant="height24" />
        <VehicleBasicInfo vehicle={vehicle} />
      </div>
    </div>
  );
}
